// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17Eta","title":"Info_title__2bNuR","selects":"Info_selects__3b7no","requiredAsterisk":"Info_requiredAsterisk__20pYU"};